/*
  Keeps the display-only Google rating line on product cards live (mobile only).
  Reads the current Google rating from the Google Reviews app's public widget page,
  caches it for 6 hours, and updates every [data-google-rating] element, including
  cards added later by infinite scroll / filtering. If anything fails, the
  server-rendered fallback values from the theme settings stay in place.
  No structured data is created.
*/
(function () {
  var config = window.googleRatingConfig;
  if (!config || !config.url || window.__googleRatingInit) return;
  window.__googleRatingInit = true;

  var CACHE_KEY = 'mh_google_rating_v1';
  var CACHE_TTL = 6 * 60 * 60 * 1000;
  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var pending = false;
  var fetching = false;
  var current = null;

  function readCache() {
    try {
      var data = JSON.parse(localStorage.getItem(CACHE_KEY));
      if (data && typeof data.rating === 'number' && typeof data.time === 'number') return data;
    } catch (e) {}
    return null;
  }

  function writeCache(data) {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify(data)); } catch (e) {}
  }

  function valid(rating, count) {
    return isFinite(rating) && rating >= 1 && rating <= 5 && isFinite(count) && count > 0;
  }

  function render() {
    if (!current) return;
    var text = (Math.round(current.rating * 10) / 10).toFixed(1);
    var fill = Math.max(0, Math.min(100, current.rating * 20)) + '%';
    var label = 'Google rating ' + text + ' out of 5';
    var count = current.count > 0 ? String(current.count) : '';
    if (count) {
      document.querySelectorAll('[data-google-reviews-heading], [data-google-reviews-subline]').forEach(function (el) {
        var tpl = el.getAttribute('data-template') || '';
        var out = tpl.replace(/\{count\}/g, count).replace(/\{rating\}/g, text);
        if (el.textContent !== out) el.textContent = out;
        el.hidden = false;
      });
    }
    document.querySelectorAll('[data-google-rating-hero]').forEach(function (el) {
      var heroKey = text + '/' + count;
      if (!count || el.getAttribute('data-google-rating-hero') === heroKey) return;
      el.setAttribute('data-google-rating-hero', heroKey);
      el.style.setProperty('--gr-fill', fill);
      el.setAttribute('aria-label', text + ' out of 5 from ' + count + ' Google reviews');
      var heroScore = el.querySelector('[data-google-rating-hero-score]');
      var heroCount = el.querySelector('[data-google-rating-hero-count]');
      if (heroScore) heroScore.textContent = text;
      if (heroCount) heroCount.textContent = count;
      el.hidden = false;
    });
    document.querySelectorAll('[data-google-rating]').forEach(function (el) {
      if (el.getAttribute('data-google-rating') === text) return;
      el.setAttribute('data-google-rating', text);
      el.style.setProperty('--gr-fill', fill);
      el.setAttribute('aria-label', label);
      var score = el.querySelector('[data-google-rating-score]');
      if (score) score.textContent = text;
    });
  }

  function load() {
    var cached = readCache();
    if (cached && valid(cached.rating, cached.count || 1)) {
      current = cached;
      render();
    }
    if (fetching || (cached && Date.now() - cached.time < CACHE_TTL)) return;
    fetching = true;

    var controller = window.AbortController ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, 10000) : null;

    fetch(config.url, { credentials: 'omit', signal: controller ? controller.signal : undefined })
      .then(function (res) { return res.ok ? res.text() : Promise.reject(new Error('status ' + res.status)); })
      .then(function (html) {
        /* The widget payload contains: "rating":4.9,"reviews_number":63 (possibly backslash-escaped) */
        var match = html.match(/\\*"rating\\*"\s*:\s*([0-5](?:\.\d+)?)\s*,\s*\\*"reviews_number\\*"\s*:\s*(\d+)/);
        if (!match) return;
        var rating = parseFloat(match[1]);
        var count = parseInt(match[2], 10);
        if (!valid(rating, count)) return;
        current = { rating: rating, count: count, time: Date.now() };
        writeCache(current);
        render();
      })
      .catch(function () {})
      .then(function () {
        fetching = false;
        if (timer) clearTimeout(timer);
      });
  }

  function start() {
    if (mobileQuery.matches || document.querySelector('[data-google-reviews-heading]')) load();
  }

  /* Cards added after load (infinite scroll, filters, quick view) */
  new MutationObserver(function () {
    if (pending || !current) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      render();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', start);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
